import Tooltip from "@mui/material/Tooltip";

export const ReportsTruncatedName = ({ value, empty = "—", maxLength }) => {
  const name =
    value == null || String(value).trim() === "" ? empty : String(value);
  const shown =
    maxLength && name !== empty && name.length > maxLength
      ? `${name.slice(0, maxLength).trimEnd()}...`
      : name;
  const showTooltip = name !== empty;

  const label = (
    <span
      className={maxLength ? undefined : "reports-truncated-name"}
      style={maxLength ? { whiteSpace: "nowrap" } : undefined}
    >
      {shown}
    </span>
  );

  if (!showTooltip) {
    return label;
  }

  return (
    <Tooltip
      title={name}
      placement="bottom"
      arrow
      PopperProps={{
        modifiers: [
          {
            name: "offset",
            options: { offset: [0, 8] },
          },
        ],
      }}
    >
      {label}
    </Tooltip>
  );
};
